module.exports = __webpack_public_path__ + "img/index09.35d6c2d5.png";